import { render, staticRenderFns } from "./BrowseGoalsFiltersDisplay.vue?vue&type=template&id=fc3b60da&scoped=true"
import script from "./BrowseGoalsFiltersDisplay.vue?vue&type=script&lang=js"
export * from "./BrowseGoalsFiltersDisplay.vue?vue&type=script&lang=js"
import style0 from "./BrowseGoalsFiltersDisplay.vue?vue&type=style&index=0&id=fc3b60da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3b60da",
  null
  
)

export default component.exports